/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation SenderRouteDelete($routeId: ID!) {
    SenderRouteDelete(routeId: $routeId) {
        message
        status
    }
} 
`
